import { API_ENDPOINT } from 'src/config/env.config';
import { BaseAPIResponse, JobseekerFeedbackCreateInfo, MentorFeedbackCreateInfo } from 'types';
import { baseApi } from './axios';

const baseUrl = API_ENDPOINT;

export const addRatingByIdJobseeker = async (args: {
	meetingId: string;
	createInfo: JobseekerFeedbackCreateInfo;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/meeting/addRatingByIdJobseeker/${args.meetingId}`, {
		...args.createInfo,
	});
	return response.data;
};

export const addRatingByIdMentor = async (args: {
	meetingId: string;
	createInfo: MentorFeedbackCreateInfo;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.patch(`${baseUrl}/meeting/addMentorRating/${args.meetingId}`, {
		...args.createInfo,
	});
	return response.data;
};
